var _path, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewersS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9815 5.35196C14.6552 5.45302 17.5502 6.9986 19.6486 10.0244C19.7556 10.1789 19.7675 10.2919 19.6546 10.4524C17.9485 12.961 15.6183 14.5482 12.6222 14.9881C8.27675 15.6241 4.83487 14.031 2.27872 10.488C2.14794 10.3038 2.142 10.1789 2.27278 9.98276C4.0383 7.40877 6.46962 5.89292 9.56077 5.42924C9.78667 5.39358 10.0185 5.36385 10.2444 5.35196C10.4881 5.34007 10.7378 5.35196 10.9815 5.35196ZM10.9756 7.11749C9.26949 7.11155 7.83686 8.51446 7.82497 10.2027C7.81308 11.9147 9.21005 13.3533 10.8923 13.3652C12.646 13.3771 14.0667 11.9861 14.0727 10.2503C14.0786 8.55013 12.6698 7.12344 10.9756 7.11749Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.956,
    cy: 10.2359,
    rx: 1.773,
    ry: 1.773,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewersS);
export default __webpack_public_path__ + "static/media/viewers_s.58342de0f35188416691548ea4aeba0c.svg";
export { ForwardRef as ReactComponent };